import { UseGqlMutationCallbacks, useMutationWithInvalidation } from '@alice-financial/api'
import { useMutationNotifier } from '../../../../notifications/useMutationNotifier'
import { useTosAcceptanceQuery } from '../queries/tosAcceptance_gen'
import { AcceptTosMutation, AcceptTosMutationVariables, useAcceptTosMutation } from './acceptTos_gen'

type UseAcceptTosMutationOptions = UseGqlMutationCallbacks<AcceptTosMutation, AcceptTosMutationVariables>

export const useAcceptTos = (orgId: number, mutationOptions?: UseAcceptTosMutationOptions) => {
  const { mutateAsync: acceptTos } = useAcceptTosMutation()
  const optionsWithNotification = useMutationNotifier({}, mutationOptions)
  return useMutationWithInvalidation(acceptTos, optionsWithNotification, [
    useTosAcceptanceQuery.getKey({ ownerId: orgId }),
  ])
}
